import React, { useState } from 'react'

export default function ASplitter(props) {
	
	const { subjId, min, setMapHeight, mapScale, visible, def } = props
	
	let startY, startH
	
	const init = (e) => {
		startY = e.clientY
		startH = document.getElementById(subjId).clientHeight
		document.documentElement.addEventListener('mousemove', drag)
		document.documentElement.addEventListener('mouseup', stop)
	}
	
	const drag = (e) => {
		const h = Math.max(startH + e.clientY - startY, min)
		setMapHeight && setMapHeight(h / mapScale)
	}
	
	const stop = (e) => {
		document.documentElement.removeEventListener('mousemove', drag)
		document.documentElement.removeEventListener('mouseup', stop)
	}
	
	const reset = () => setMapHeight && setMapHeight(def)
	
	return <div className={'a-splitter a-splitter-vertical' + (visible ? '' : ' hidden')} onDoubleClick={reset}  >
		<div className="a-splitter-gutter" onMouseDown={(e) => init(e)} >
			<div className="a-splitter-gutter-handle">
			</div>
		</div>
	</div>
		
}

